import React from 'react';
import Header from '../Header';
import ContactUsFooter from '../ContactUs/ContactUsFooter';
import './Implants.css';

const Implants = () => {
    const pricing = [
        { type: "Bone Augmentation", price: "₱25,000 UP" },
        { type: "Dental Implant Screw", price: "₱45,000 UP" },
        { type: "Dental Implant Abutment", price: "₱45,000 UP" },
        { type: "Dental Implant Crown", price: "₱15,000 UP" },
        { type: "Clear Aligners", price: "₱195,000 UP" },
        { type: "TOTAL", price: "₱105,000" },
    ];
 

    return (
        <>
        <Header/>
        <div className="implants-container">
            <div className="implants-content">
                <h1>IMPLANTS</h1>
                <p>
                Dental implants are artificial tooth roots surgically placed into the jawbone to support replacement teeth. 
                This procedure involves multiple steps, including implant placement, osseointegration (bone fusion), 
                and the attachment of a restoration (crown, bridge, or denture). Implants offer a stable and durable solution 
                for replacing missing teeth, improving both function and aesthetics.
                </p>
                <h2>Pricing</h2>
                <table className="implants-table">
                        <thead>
                            <tr>
                                <th>Type of Surgery</th>
                                <th>Price</th>
                            </tr>
                        </thead>
                        <tbody>
                            {pricing.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.type}</td>
                                    <td>{item.price}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <ContactUsFooter />
        </>
    );
};


export default Implants;